import { Plugins } from '@leverege/plugin';
import { ModelFactory } from '@leverege/ui-plugin';
import StringUtil from '@leverege/string-util';
import AttributeColumnModel from "../table/type/AttributeColumnModel.js";
import { ArrayPrimitiveAttributeColumnModel } from "../table/type/index.js";
export default {
  install: opts => {
    let columnCreatorOnChange = null;

    // TODO: This mechanism is creating columns for attributes based on the
    // the valueType of the attribute. We will also want to be able to install
    // a column renderer for a particular attribute type (do able now) but remove
    // the default created attribute column 

    const dirty = evt => {
      // Fire a change to the column creator mechanism
      // when attributes are added/removed
      if (columnCreatorOnChange) {
        columnCreatorOnChange();
      }
    };
    Plugins.on('Attribute', dirty);
    Plugins.on('Model', dirty); // we use models as well

    // Add a Plugin to convert Attributes into Columns
    Plugins.add('ColumnCreator', {
      name: 'AttributeColumnCreator',
      onChange: cb => {
        columnCreatorOnChange = cb;
      },
      create: () => {
        const plgs = Plugins.get('Attribute');
        const columns = [];
        plgs.forEach(attr => {
          const d = attributeToColumn(attr);
          if (d != null) {
            columns.push(d);
          }
        });
        return columns;
      }
    });

    /**
     * Creates a Column setup to use the attribute to display the value.
     */
    function attributeToColumn(attr) {
      const {
        valueType
      } = attr;
      const isArray = valueType?.endsWith('*');
      let model = ModelFactory.get(`attr.column.${valueType}`);
      // console.log( `attr.column.${attr.valueType}`, model )
      let formatter = null;
      if (model == null) {
        formatter = ModelFactory.get(isArray ? `attr.formatter.${valueType.replace('*', '')}` : `attr.formatter.${valueType}`);
        if (formatter) {
          // we can create a generic attribute column and set the formatter
          if (isArray) {
            model = ArrayPrimitiveAttributeColumnModel;
          } else {
            model = AttributeColumnModel;
          }
        } else {
          // eslint-disable-next-line no-console
          // console.log( `No Model for: attr.column.${attr.valueType}====>`, model )
          return null;
        }
      }
      return {
        name: attr.displayName || StringUtil.camelCaseToTitleCase(attr.name),
        objectType: attr.objectType,
        layout: {
          ...attr.layout
        },
        create: () => {
          let json = model.create(attr.name, attr.objectType);
          if (formatter) {
            json = model.setFormatter(json, formatter.create());
          }
          return json;
        }
      };
    }
  }
};